import { SelectField, SelectOption } from 'form';
import { translate } from 'i18n';

type PercentageLightBlueProps = {
  label?: string;
  name?: string;
  infoTooltip?: string;
};

const PercentageLightBlueOptions: SelectOption[] = [
  { label: translate('backlog.percentageLightBlue.options.notAvailable', { namespace: 'features' }), value: undefined },
  { label: '<5%', value: 0.05 },
  { label: '10%', value: 0.1 },
  { label: '20%', value: 0.2 },
  { label: '30%', value: 0.3 },
  { label: '40%', value: 0.4 },
  { label: '50%', value: 0.5 },
  { label: '100%', value: 1 },
];

export const PercentageLightBlue = ({
  label = translate('backlog.percentageLightBlue.label', { namespace: 'features' }),
  name = 'percentage_light_blue',
  infoTooltip,
}: PercentageLightBlueProps) => {
  return (
    <SelectField
      label={label}
      name={name}
      type="text"
      options={PercentageLightBlueOptions}
      required={false}
      infoTooltip={infoTooltip}
    />
  );
};
